import { HandleReportsAnalyticalActivitiesByStudentServiceInterface } from 'domain/services';
import { HandleReportsAnalyticalActivitiesByStudent } from 'domain/usecases';

export class ReportsAnalyticalService
  implements HandleReportsAnalyticalActivitiesByStudentServiceInterface
{
  constructor(
    private readonly _handleReportsAnalyticalActivitiesByStudent: HandleReportsAnalyticalActivitiesByStudent,
  ) {}

  async handleReportsAnalyticalActivitiesByStudent(
    params: HandleReportsAnalyticalActivitiesByStudent.Params,
  ): Promise<HandleReportsAnalyticalActivitiesByStudent.Result> {
    return await this._handleReportsAnalyticalActivitiesByStudent.execute(
      params,
    );
  }
}
